"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _EventList_1 = require("./_EventList");
exports._TopicConfigurationDeprecated = {
    type: "structure",
    required: [],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        Events: {
            shape: _EventList_1._EventList,
            locationName: "Event"
        },
        Event: {
            shape: {
                type: "string"
            }
        },
        Topic: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_TopicConfigurationDeprecated.js.map